<div class="app-page">
  <router-outlet></router-outlet>
  <app-alert></app-alert>
</div>
